export default function openBag() {
  let open = '[data-openbag]';
  let close = '[data-closebag]';
  let bag = $('[data-bag]');
  let bagOpen = 'bag--open';
  $(open).click((e) => {
    e.preventDefault();
    bag.addClass(bagOpen);
    $('body').css('overflow-y', 'hidden');
  });
  $(close).click(() => {
    if ($('.bag__stage--success').is(':visible')) {
      location.reload();
    } else {
      bag.removeClass(bagOpen);
      $('body').css('overflow-y', 'auto');
    }
  });

  $('body').on('change', '#bag .change-quantity', function (event) {
    var input = $(this);
    if (parseInt(input.val()) < 1) input.val('1');
    var qtd = input.val();
    var id = input.parents('.bag__iten').attr('data-id');
    var url = $('#bag').attr('data-url');

    $.ajax({
      url: url,
      type: 'POST',
      dataType: 'json',
      data: {
        id: id,
        qtd: qtd,
        '_token': $('meta[name="csrf-token"]').attr('content')
      },
      error: function () {
        console.error('cart quantity update error');
      },
      success: function (json) {
        if (json.status) {
          let resume = "";
          $.each(json.cart, function (index, el) {
            resume += `<tr data-id="${el.id}">
						<td class="table__td">${el.qtd}</td>
						<td class="table__td table__td--bold"><a href="${el.url}">${el.name}</a></td>
						<td class="table__td">${el.cod}</td>
						<td class="table__td table__delete">X</td>
						</tr>`;
          });
          $('.bagNumber').html(json.qtd);
          $('.bag-resume').html(resume);
        }
      }
    });
  });

  $('body').on('click', '.bag-resume .table__delete', function (event) {
    var btn = $(this);
    var id = btn.parents('tr').attr('data-id');
    var url = $('#bag').attr('data-url');

    $.ajax({
      url: url,
      type: 'POST',
      dataType: 'json',
      data: {
        id: id,
        remove: true,
        '_token': $('meta[name="csrf-token"]').attr('content')
      },
      error: function () {
        console.error('cart remove error');
      },
      success: function (json) {
        if (json.status) {
          btn.parents('tr').remove();
          let content = "";
          $.each(json.cart, function (index, el) {
            content += `<div class="bag__iten" data-id="${el.id}">
						<a class="bag__image" href="${el.url}">
						<img src="${el.image}" alt="${el.name} - Soprano" class="img-fluid">
						</a>
						<div class="bag__infos">
						<form action="">
						<div class="form-row">
						<div class="col-md-6">
						<p class="form__text">${jsi18n.product}</p>
						<input type="text" name="product" disabled value="${el.name}" class="form__input form__input--bold">
						</div>
						<div class="col-md-6">
						<p class="form__text">${jsi18n.cod}</p>
						<input type="text" name="code" disabled value="${el.cod}" class="form__input">
						</div>
						<div class="col-md-3">
						<p class="form__text">${jsi18n.qtd}</p>
						<input type="number" name="qtd" value="${el.qtd}" class="form__input">
						</div>
						</div>
						</form>
						</div>
						</div>`;
          });
          $('.bag__itensContent').html(content);
          if (json.qtd == 0) {
            location.reload();
          } else {
            $('.bagNumber').html(json.qtd);
          }
        }
      }
    });
  });

  $('.bag-clear-products').click(function (e) {
    e.preventDefault();
    var btn = $(this);
    $.ajax({
      url: btn.attr('href'),
      type: 'GET',
      dataType: 'json',
      complete: function () {
        location.reload();
      }
    });
  });
}